import { ClaudeTemplate } from "../types";

export const pinterestTemplate: ClaudeTemplate = {
  id: "pinterest",
  tool: "Pinterest Ads Manager",
  url: "https://ads.pinterest.com/",
  hierarchy: "Ad account → Campaign → Ad group → Ads (Pins promocionados)",
  idHint: "ID de la campaña en el listado o en la URL al abrirla",
  steps: `
### 1. Entrar en la cuenta (puede que ya estés dentro)
1. Abre Pinterest Ads Manager ({{url}}). Si ya está abierto, sigue.
2. Elige la **Ad account** de {{client}}. Si hay varias, pregunta.

### 2. Campaign
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, "Create campaign" (modo manual, no automatizado):
   - Objective según {{goal.kpi}}: CPM → Brand awareness; CPV → Video views; CPC → Consideration (clics); CPA/CPL → Conversions.
   - Campaign name: {{names.order}}
   - Campaign budget: lifetime {{goal.budget}} del {{goal.startDate}} al {{goal.endDate}} (o en el ad group, si la cuenta no permite presupuesto de campaña).

### 3. Ad group
1. Ad group name: {{names.line}}
2. Targeting: ubicación {{target.geography}} (país {{goal.country}}), edad {{target.age}}, sexo {{target.gender}}, idioma {{target.language}}, dispositivos {{target.technology}}, intereses y palabras clave {{target.interests}}, audiencias {{target.audience}}, exclusiones {{target.exclusions}}.
3. Expanded targeting: desactivado, salvo que las notas digan otra cosa.
4. Bid: automático por defecto; si las notas piden coste controlado, puja objetivo en torno a {{goal.netUnitCost}}.

### 4. Ads
1. Usa Pins existentes de la cuenta de {{brand}} si el briefing los indica; si no, crea Pins con las piezas del bloque "Creatividades".
2. Título y descripción: bloque "Copies". URL de destino con UTM: bloque "URLs de destino".
3. Deja todo **en pausa**. No lo lances sin mi confirmación.
`,
};
